import { PartnerSearchByBrResponse, ServiceRole } from 'pco-product-service-internal-consumer';
import { isEbankingServiceRoleProperties } from '../../../productSpecificProperties';

export type PrivateBankingServiceRole = ServiceRole;

export const buildPartnerFromServiceRole = (serviceRole: PrivateBankingServiceRole): PartnerSearchByBrResponse => {
  const properties = serviceRole.productSpecificProperties;
  const ebanking = isEbankingServiceRoleProperties(properties) ? properties : undefined;

  return {
    globalPartnerId: serviceRole.partnerNumber,
    techId: serviceRole.partnerUid,
    partnerType: serviceRole.partnerType,
    mainDomicileCountry: serviceRole.domicileCountry,
    fullName:
      serviceRole.fullName ?? [serviceRole.firstName, serviceRole.lastName].filter((n): n is string => !!n).join(' '),
    lastLogin: ebanking?.lastLogin,
    isBlocked: ebanking?.isBlocked,
    jNr: ebanking?.jNumber,
  };
};
